export default __webpack_public_path__ + "static/media/basiercircle-regular-webfont.af78d522.ttf";